// extracted by mini-css-extract-plugin
var _1 = "_goldTransactionEarmark-module__button-container";
var _2 = "_goldTransactionEarmark-module__container";
var _3 = "_goldTransactionEarmark-module__form-container";
var _4 = "_goldTransactionEarmark-module__span-2";
export { _1 as "button-container", _2 as "container", _3 as "form-container", _4 as "span-2" }
